import '../sentry'
import '@ui/animated/nativewindReanimated'

import React, { useEffect } from 'react'
import 'react-native-reanimated'
// import GestureHandlerRootView from 'components/GestureHandlerRootView/GestureHandlerRootView.web'

import { BrillenSdkPlaceholderUi } from '@modules/brillen-sdk'
import { Stack, useNavigationContainerRef } from 'expo-router'
import '../global.css'

import { PortalHost } from '@gorhom/portal'
import * as Sentry from '@sentry/react-native'

import Providers from 'providers/Providers'
import { widthDefault } from '@ui/theme/values'
import { StandaloneStaffLoginModal } from '@user/modals/StaffLogin/StandaloneStaffLoginModal'
import GlassesTypeModal from '@order/modals/GlassesType/GlassesTypeModal'
import AppConfig from 'config'
import { useSdkMeasureListenerPd } from 'hooks/measurements/useSdkMeasureListener'
import { Platform, View } from 'react-native'
import { registerDevMenu } from 'utils/dev/devMenu'

import AuthRedirects from 'providers/AuthRedirect'
import BackgroundQrScanner from '@/common/CodeScanner'
import Version from '@shell/Version/Version'
import useScreenTracking from 'hooks/analytics/useScreenTracking'
import useSessionTracking from 'hooks/analytics/useSessionTracking'
import useAutoUpdate from 'hooks/useAutoUpdate'
import useSentryContext from 'hooks/useSentryContext'
import { routingInstrumentation } from '../sentry'

import { GlobalErrorBoundary } from 'providers/AppErrorBoundary'
import InactiveScreen from '@screens/app/inactive'
import OfflineScreen from '@screens/app/offline'
import UpdateScreen from '@screens/app/update'
import { useTimestampSync } from 'hooks/useSession'
import { usePaymentSuccessRefresh } from 'hooks/customer/useRefreshCustomer'
import { useSyncLastValidStore } from 'hooks/store/useLastValidStore'
import Topbar from '@shell/Topbar'
import { MeasurementProvider } from 'features/measurements/MeasurementProvider'

export const unstable_settings = {
  // Ensure any route can link back to `/`
  initialRouteName: 'index',
}

registerDevMenu()

const WebContainer = ({ children }: { children: React.ReactNode }) => {
  if (Platform.OS === 'web') {
    return (
      <View className="flex flex-1 items-center bg-white">
        <View
          className="relative min-h-full flex-1 overflow-hidden bg-white"
          style={{ width: '100%', maxWidth: widthDefault }}
        >
          {children}
        </View>
      </View>
    )
  }

  return <>{children}</>
}

const MeasureListener = () => {
  useSdkMeasureListenerPd()

  return null
}

const Tracking = () => {
  useScreenTracking()
  useSessionTracking()
  useSentryContext()
  useAutoUpdate()

  return null
}

const TimestampSync = () => {
  useTimestampSync()

  return null
}

const LatestStoreSync = () => {
  useSyncLastValidStore()

  return null
}

const PaymentSuccessRefresh = () => {
  usePaymentSuccessRefresh()

  return null
}

function AppLayout() {
  const ref = useNavigationContainerRef()

  useEffect(() => {
    if (ref) {
      routingInstrumentation.registerNavigationContainer(ref)
    }
  }, [ref])

  return (
    <GlobalErrorBoundary>
      <Providers>
        <MeasurementProvider>
          <Tracking />
          <WebContainer>
            <MeasureListener />
            <AuthRedirects />
            <TimestampSync />
            <Stack
              screenOptions={{
                headerShadowVisible: false,
                headerShown: false,
                // header: (props) => <AppTopbar {...props} />,
                animation: 'slide_from_right',
                contentStyle: { backgroundColor: '#ffffff' },
                // gestureEnabled: false, // TODO: check it on iOS
                freezeOnBlur: true,
              }}
            >
              {/* <Stack.Screen
                name="(drawer)"
                options={{
                  headerShown: false,
                }}
              /> */}
              <Stack.Screen
                name="dev"
                options={{
                  headerShown: false,
                }}
              />
              <Stack.Screen
                name="admin"
                options={{
                  presentation: 'modal',
                  headerShown: false,
                  contentStyle: {
                    backgroundColor: 'transparent',
                    justifyContent: 'flex-end',
                  },
                }}
              />
            </Stack>
            <InactiveScreen />
            <GlassesTypeModal />
            <StandaloneStaffLoginModal />
            <Version />
            <Topbar />
          </WebContainer>
          <PortalHost name="root" />
          {/* This allows to open persistent modals on top the root portal host */}
          <PortalHost name="persistent" />
          <BackgroundQrScanner />
          <BrillenSdkPlaceholderUi />
          <PaymentSuccessRefresh />
          <UpdateScreen />
          <LatestStoreSync />
          <OfflineScreen />
        </MeasurementProvider>
      </Providers>
    </GlobalErrorBoundary>
  )
}

const AppWrapper = AppConfig.sentry.enabled ? Sentry.wrap(AppLayout) : AppLayout

export default AppWrapper
